;(function( window, document, bq ){ window.jQuery(function($) { 'use strict';

if (typeof window.bqHandleRecommendationImageError !== 'function') {
    window.bqHandleRecommendationImageError = function(img) {
        if (!img) return;
        var state           = img.getAttribute('data-fallback-state');
        var supplierFallback = img.getAttribute('data-supplier-fallback') || '';
        var defaultFallback  = img.getAttribute('data-default-fallback') || '';
        if (state !== 'supplier' && supplierFallback) {
            img.setAttribute('data-fallback-state', 'supplier');
            img.src = supplierFallback;
            return;
        }
        if (state !== 'default' && defaultFallback) {
            img.setAttribute('data-fallback-state', 'default');
            img.src = defaultFallback;
            return;
        }
        img.onerror = null;
    };
}

bq.forecastsManager = function(element, options) {
    this.$el     = $(element);
    this.options = $.extend(true, {}, bq.forecastsManager.DEFAULTS, this.$el.data(), options);
    this._relationKeys              = {};
    this._supplierNames             = {};
    this._savedProducts             = {};
    this._relImportAllSupplierNames = [];
    this._schedState = {
        currentYear:     new Date().getFullYear(),
        startDate:       null,
        endDate:         null,
        hoverDate:       null,
        savedSelections: []
    };
    this.init();
};

bq.forecastsManager.DEFAULTS = {
    getRelationKeysUrl:                   '',
    searchUrl:                            '',
    relationSearchUrl:                    '',
    logUrl:                               '',
    supplierImageBaseUrl:                 '',
    historicalDownloadBaseUrl:            '',
    qtyChangesDownloadBaseUrl:            '',
    readSchedulesUrl:                     '',
    writeScheduleUrl:                     '',
    updateScheduleUrl:                    '',
    deleteScheduleUrl:                    '',
    writeScheduleGroupsUrl:               '',
    readScheduleGroupsUrl:                '',
    listGroupsUrl:                        '',
    uploadScheduleGroupsUrl:              '',
    readScheduleGroupUploadsUrl:          '',
    downloadScheduleGroupUploadUrl:       '',
    downloadScheduleGroupAssociationsUrl: '',
    listSuppliersUrl:                     '',
    importRelationsUrl:                   '',
    exportRelationsUrl:                   '',
    contentGroups:                        '[]',
    labels: {
        selectSupplier:               '-- Select Supplier --',
        selectSku:                    '-- Select SKU --',
        searchProductsPlaceholder:    'Type to search products...',
        selectProductToAdd:           'Select a product to add...',
        saving:                       'Saving...',
        saved:                        'Saved',
        failed:                       'Failed',
        selectBothDates:              'Please select both a start date and an end date.',
        startBeforeEnd:               'Start date must be on or before end date.',
        pleaseEnterScheduleName:      'Please enter a schedule name',
        pleaseSelectDateRange:        'Please select at least one date range',
        failedToUpdateSchedule:       'Failed to update schedule',
        failedToSaveSchedule:         'Failed to save schedule',
        failedToLoadSchedules:        'Failed to load schedules',
        noSchedulesSaved:             'No schedules saved yet.',
        noPeriodsSelected:            'No periods selected yet',
        remove:                       'Remove',
        scheduleForecastingPeriods:   'Schedule Forecasting Periods',
        manageScheduleGroups:         'Manage Schedule Groups',
        deleteScheduleLabel:          'Delete Schedule',
        areYouSureDelete:             'Are you sure you want to delete this schedule?',
        failedToDeleteSchedule:       'Failed to delete schedule',
        manageContentGroups:          'Manage Content Groups',
        selectContentGroupsFor:       'Select content groups for this schedule:',
        noContentGroups:              'No content groups available.',
        cancel:                       'Cancel',
        save:                         'Save',
        loadingScheduleGroups:        'Loading schedule groups...',
        failedToLoadScheduleGroups:   'Failed to load schedule groups',
        scheduleGroupsNotLoaded:      'Schedule groups have not finished loading',
        noChangesToSave:              'No changes to save',
        preparingBatches:             'Preparing batches...',
        savingBatch:                  'Saving batch',
        of:                           'of',
        processed:                    'processed',
        conflicts:                    'conflicts',
        failedLower:                  'failed',
        done:                         'Done.',
        failedGroupIds:               'Failed group IDs:',
        conflictsLabel:               'Conflicts:',
        group:                        'Group',
        isCurrentlyAssociatedWith:    'is currently associated with',
        loading:                      'Loading...',
        noRecentUploads:              'No recent uploads',
        fileName:                     'File Name',
        status:                       'Status',
        rows:                         'Rows',
        download:                     'Download',
        failedToLoadUploads:          'Failed to load uploads',
        pleaseSelectCsvFile:          'Please select a CSV file',
        uploading:                    'Uploading...',
        uploadAccepted:               'Upload accepted.',
        rowsSubmitted:                'row(s) submitted for processing.',
        uploadId:                     'Upload ID:',
        uploadFailed:                 'Upload failed.',
        upload:                       'Upload',
        editSchedule:                 'Edit Schedule',
        createSchedule:               'Create Schedule',
        overlapWarning:               'The selected date range overlaps with an existing range: ',
        selectNonOverlapping:         'Please select a non-overlapping date range.',
        loadingSuppliersMsg:          'Loading suppliers...',
        noSuppliersFound:             'No suppliers found',
        failedToLoadSuppliers:        'Failed to load suppliers',
        copied:                       'Copied!',
        copySuppliers:                'Copy Suppliers',
        importing:                    'Importing...',
        importSuccessful:             'Import successful.',
        relationshipsLoaded:          'relationship(s) loaded.',
        importFailed:                 'Import failed.',
        import:                       'Import',
        monthNames:                   ['January','February','March','April','May','June','July','August','September','October','November','December'],
        dayHeaders:                   ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
    }
};

bq.forecastsManager.prototype = {

    _isNewDesign: function() {
        return typeof bq.getIsThemeNew === 'function'
            ? bq.getIsThemeNew()
            : $('body').is('.theme-new, .light-theme, .dark-theme');
    },

    init: function() {
        var self = this;
        var o    = this.options;

        this._defaultSupplierImageUrl = o.supplierImageBaseUrl + 'placeholder.jpg';
        this._currentYearBase = new Date().getFullYear();
        this._minYear         = this._currentYearBase;
        this._maxYear         = this._currentYearBase + 2;
        this._schedState.currentYear = this._currentYearBase;

        try {
            this._contentGroups = typeof o.contentGroups === 'string'
                ? JSON.parse(o.contentGroups)
                : (o.contentGroups || []);
        } catch(e) {
            this._contentGroups = [];
        }

        // expose schedRemoveSelection globally — used in onclick attributes of rendered HTML
        window.schedRemoveSelection = function(index) { self._removeSelection(index); };

        this._updateRelationsContainer('', '', '');
        this._loadRelationKeys();
        this._initRelationProductSearch();
        this._initRecommendationsSearch();
        this._initHistoricalDataModal();
        this._initQtyChangesModal();
        this._initSchedules();
        this._initRelationImportExport();
    },

    // ─── Utilities ────────────────────────────────────────────────────────────

    _escHTML: function(s) {
        return $('<div>').text(s || '').html();
    },

    _escHTMLAttr: function(s) {
        return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },

    _imageHtml: function(imageUrl, supplierId, size) {
        var parsedId         = parseInt(supplierId, 10);
        var supplierFallback = parsedId ? (this.options.supplierImageBaseUrl + parsedId + '.jpg') : this._defaultSupplierImageUrl;
        var resolvedUrl      = imageUrl ? String(imageUrl) : supplierFallback;
        var esc = this._escHTMLAttr.bind(this);
        return '<img src="' + esc(resolvedUrl) + '" alt="" class="rec-img--bordered rec-img--sm" ' +
               'data-fallback-state="primary" data-supplier-fallback="' + esc(supplierFallback) + '" data-default-fallback="' + esc(this._defaultSupplierImageUrl) + '" ' +
               'onerror="bqHandleRecommendationImageError(this)" />';
    },

    _getContentGroupId: function() {
        return $('#bq-recs-content-group').val();
    },

    // ─── Relations Selector ───────────────────────────────────────────────────

    _loadRelationKeys: function() {
        var self = this;
        $.ajax({
            url: this.options.getRelationKeysUrl, type: 'GET', dataType: 'json',
            success: function(response) {
                if (response.success && response.keys) {
                    self._relationKeys  = response.keys;
                    self._supplierNames = response.supplierNames || {};
                    self._populateSupplierDropdown();
                }
            }
        });
    },

    _populateSupplierDropdown: function() {
        var self    = this;
        var labels  = bq.messages.recommendations;
        var $select = $('#relation-supplier-select');
        $select.empty().append('<option value="">' + labels.selectSupplier + '</option>');
        var suppliers = Object.keys(this._relationKeys).sort();
        $.each(suppliers, function(_, supplierId) {
            var name        = self._supplierNames[supplierId] || supplierId;
            var displayText = name + ' (' + supplierId + ')';
            $select.append('<option value="' + $('<div>').text(supplierId).html() + '">' + $('<div>').text(displayText).html() + '</option>');
        });
    },

    _populateSkuDropdown: function(supplierId) {
        var labels  = bq.messages.recommendations;
        var $select = $('#relation-sku-select');
        $select.empty().append('<option value="">' + labels.selectSku + '</option>');
        if (!supplierId || !this._relationKeys[supplierId]) {
            $select.prop('disabled', true);
            return;
        }
        var skus = this._relationKeys[supplierId].slice().sort();
        $.each(skus, function(_, sku) {
            $select.append('<option value="' + $('<div>').text(sku).html() + '">' + $('<div>').text(sku).html() + '</option>');
        });
        $select.prop('disabled', false);
    },

    _updateRelationsContainer: function(supplierId, sku, productId) {
        var $c = $('#bqRelations');
        $c.attr('data-supplier-id', supplierId || '');
        $c.attr('data-sku',         sku         || '');
        $c.attr('data-product-id',  productId   || '');
    },

    // ─── Product Search (Relations Tab) ───────────────────────────────────────

    _initRelationProductSearch: function() {
        var self    = this;
        var o       = this.options;
        var labels  = o.labels;
        var $search = $('#relation-product-search');

        if ($search.data('select2') || typeof $.fn.select2 === 'undefined') return;

        $search.select2({
            placeholder:        labels.searchProductsPlaceholder,
            allowClear:         true,
            minimumInputLength: 2,
            ajax: {
                url: o.relationSearchUrl, type: 'GET', dataType: 'json', quietMillis: 250,
                data: function(term, page) {
                    return { q: term || '', page: page || 1, page_limit: 20, no_filters: true };
                },
                results: function(data) {
                    if (!data || typeof data !== 'object') return { results: [], more: false };
                    return { results: Array.isArray(data.results) ? data.results : [], more: !!(data && data.more) };
                }
            },
            formatResult: function(item) {
                if (!item || !item.data) return '';
                var d   = item.data;
                var esc = function(s) { return $('<div/>').text(s || '').html(); };
                var html = '<div class="rec-search-result">' + self._imageHtml(d.image, d.supplier_id, 36) + '<div>';
                html += '<div class="rec-search-result__name">' + esc(d.name) + '</div>';
                html += '<div class="rec-search-result__meta">';
                if (d.supplier_name) html += '<span>' + esc(d.supplier_name) + '</span>';
                else if (d.supplier_id) html += '<span>Supplier #' + esc(d.supplier_id) + '</span>';
                if (d.supplier_sku) {
                    if (d.supplier_name || d.supplier_id) html += ' &middot; ';
                    html += '<span>SKU: ' + esc(d.supplier_sku) + '</span>';
                }
                return html + '</div></div></div>';
            },
            formatSelection: function(item) {
                if (!item || !item.data) return item.text || '';
                var d = item.data, parts = [];
                if (d.supplier_name) parts.push(d.supplier_name);
                else if (d.supplier_id) parts.push('Supplier #' + d.supplier_id);
                if (d.supplier_sku) parts.push(d.supplier_sku);
                if (d.name) parts.push(d.name);
                return parts.length > 0 ? parts.join(' · ') : (item.text || '');
            },
            escapeMarkup: function(m) { return m; }
        }).on('change', function() {
            var sel = $(this).select2('data');
            if (!sel || !sel.data) return;
            var d          = sel.data;
            var supplierId = d.supplier_id  || '';
            var sku        = d.supplier_sku || '';
            var productId  = d.product_id   || '';
            if (supplierId && sku) {
                self._updateRelationsContainer(supplierId, sku, productId);
                if (self._relationKeys[supplierId] && self._relationKeys[supplierId].indexOf(sku) !== -1) {
                    $('#relation-supplier-select').val(supplierId).trigger('change');
                    setTimeout(function() { $('#relation-sku-select').val(sku).trigger('change'); }, 100);
                }
            }
            $(this).select2('val', '');
        });

        $('#relation-supplier-select').on('change.forecastsManager', function() {
            var supplierId = $(this).val();
            self._populateSkuDropdown(supplierId);
            self._updateRelationsContainer(supplierId, '', '');
        });

        $('#relation-sku-select').on('change.forecastsManager', function() {
            self._updateRelationsContainer($('#relation-supplier-select').val(), $(this).val(), '');
        });
    },

    // ─── Product Search (Forecasts Tab) ───────────────────────────────────────

    _initRecommendationsSearch: function() {
        var self    = this;
        var o       = this.options;
        var labels  = o.labels;
        var $search = $('#recommendations-product-search');

        if ($search.data('select2') || typeof $.fn.select2 === 'undefined') return;

        $search.select2({
            placeholder:        labels.searchProductsPlaceholder,
            allowClear:         true,
            minimumInputLength: 2,
            ajax: {
                url: o.searchUrl, type: 'GET', dataType: 'json', quietMillis: 250,
                data: function(term, page) {
                    var cgId   = self._getContentGroupId();
                    var params = { q: term || '', page: page || 1, page_limit: 20 };
                    if (cgId !== '' && cgId !== null && cgId !== undefined) {
                        params.content_group_id = cgId;
                    } else {
                        params.no_filters = true;
                    }
                    return params;
                },
                results: function(data) {
                    if (!data || typeof data !== 'object') return { results: [], more: false };
                    var results = Array.isArray(data.results) ? data.results : [];
                    results = results.filter(function(item) {
                        if (!item || !item.data) return true;
                        var d = item.data;
                        return !self._savedProducts[String(d.supplier_id || '') + '|' + String(d.supplier_sku || '')];
                    });
                    return { results: results, more: !!(data && data.more) };
                }
            },
            formatResult: function(item) {
                if (!item || !item.data) return '';
                var d = item.data;
                item._recommendation_data = { supplier_id: d.supplier_id, sku: d.supplier_sku, name: d.name, supplier_name: d.supplier_name };
                var esc = function(s) { return $('<div/>').text(s || '').html(); };
                var html = '<div class="recommendation-search-item rec-search-result" data-item-id="' + item.id + '">' +
                           self._imageHtml(d.image, d.supplier_id, 36) + '<div>';
                html += '<div class="rec-search-result__name">' + esc(d.name) + '</div>';
                html += '<div class="rec-search-result__meta">';
                if (d.supplier_name) html += '<span>' + esc(d.supplier_name) + '</span>';
                else if (d.supplier_id) html += '<span>Supplier #' + esc(d.supplier_id) + '</span>';
                if (d.supplier_sku) {
                    if (d.supplier_name || d.supplier_id) html += ' &middot; ';
                    html += '<span>SKU: ' + esc(d.supplier_sku) + '</span>';
                }
                return html + '</div><div class="recommendation-status rec-search-result__status"></div></div></div>';
            },
            formatSelection: function() { return labels.selectProductToAdd; },
            escapeMarkup:    function(m) { return m; }
        }).on('select2-selecting', function(e) {
            e.preventDefault();
            var item = e.object || e.choice;
            if (!item) return;
            var d          = item._recommendation_data || item.data || item;
            var supplierId = d.supplier_id  || d.supplierId  || '';
            var sku        = d.supplier_sku || d.sku         || '';
            var key        = String(supplierId) + '|' + String(sku);
            if (!supplierId || !sku) return;
            var $itemDiv = $('#select2-drop .recommendation-search-item[data-item-id="' + item.id + '"]');
            if ($itemDiv.length === 0 || $itemDiv.data('saving')) return;
            $itemDiv.data('saving', true);
            var $status = $itemDiv.find('.recommendation-status');
            $status.text(labels.saving).css('color', '#0066cc');
            $itemDiv.css('pointer-events', 'none');
            var payload = { supplier_id: String(supplierId), sku: String(sku), status: 'ACTIVE' };
            var cgId    = self._getContentGroupId();
            if (cgId !== '') payload.content_group_id = cgId;
            $.ajax({ url: o.logUrl, type: 'POST', dataType: 'json', contentType: 'application/json', data: JSON.stringify(payload) })
                .done(function(resp) {
                    if (resp && resp.success) {
                        $status.text(labels.saved).css('color', '#28a745');
                        self._savedProducts[key] = true;
                        $itemDiv.fadeOut(1000, function() { $itemDiv.remove(); });
                        if (typeof window.loadRecommendations === 'function') {
                            setTimeout(function() { window.loadRecommendations(); }, 500);
                        }
                    } else {
                        self._showItemError($itemDiv, $status, labels.failed);
                    }
                })
                .fail(function() { self._showItemError($itemDiv, $status, labels.failed); });
        });
    },

    _showItemError: function($itemDiv, $status, msg) {
        $status.text(msg).css('color', '#dc3545');
        setTimeout(function() { $itemDiv.css('pointer-events', '').data('saving', false); }, 5000);
        setTimeout(function() { $status.fadeOut(500, function() { $status.text('').css('color', '').show(); }); }, 5000);
    },

    // ─── Historical Data Modal ─────────────────────────────────────────────────

    _initHistoricalDataModal: function() {
        var o      = this.options;
        var labels = o.labels;
        var $modal   = $('#historical-data-modal');
        var $errorEl = $('#hist-date-error');

        $('#historical-data-btn').on('click.forecastsManager', function() { $errorEl.hide(); $modal.css('display', 'flex'); });
        $('#hist-cancel-btn').on('click.forecastsManager', function() { $modal.hide(); });
        $modal.on('click.forecastsManager', function(e) { if (e.target === $modal[0]) $modal.hide(); });
        $('#hist-confirm-btn').on('click.forecastsManager', function() {
            var startDate = this._getDownloadDateValue('#hist-start-date');
            var endDate   = this._getDownloadDateValue('#hist-end-date');
            if (!startDate || !endDate) { $errorEl.text(labels.selectBothDates).show(); return; }
            if (startDate > endDate) { $errorEl.text(labels.startBeforeEnd).show(); return; }
            $errorEl.hide(); $modal.hide();
            var base = o.historicalDownloadBaseUrl;
            window.location.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'start_date=' + encodeURIComponent(startDate) + '&end_date=' + encodeURIComponent(endDate);
        }.bind(this));
    },

    // ─── Qty Changes Modal ────────────────────────────────────────────────────

    _initQtyChangesModal: function() {
        var o      = this.options;
        var labels = o.labels;
        var $modal   = $('#qty-changes-modal');
        var $errorEl = $('#qty-date-error');

        $('#qty-changes-btn').on('click.forecastsManager', function() { $errorEl.hide(); $modal.css('display', 'flex'); });
        $('#qty-cancel-btn').on('click.forecastsManager', function() { $modal.hide(); });
        $modal.on('click.forecastsManager', function(e) { if (e.target === $modal[0]) $modal.hide(); });
        $('#qty-confirm-btn').on('click.forecastsManager', function() {
            var startDate = this._getDownloadDateValue('#qty-start-date');
            var endDate   = this._getDownloadDateValue('#qty-end-date');
            if (!startDate || !endDate) { $errorEl.text(labels.selectBothDates).show(); return; }
            if (startDate > endDate) { $errorEl.text(labels.startBeforeEnd).show(); return; }
            $errorEl.hide(); $modal.hide();
            var base = o.qtyChangesDownloadBaseUrl;
            window.location.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'start_date=' + encodeURIComponent(startDate) + '&end_date=' + encodeURIComponent(endDate);
        }.bind(this));
    },

    _getDownloadDateValue: function(selector) {
        var rawValue = $.trim($(selector).val());

        if (!rawValue) {
            return '';
        }

        if (!this._isNewDesign()) {
            return rawValue;
        }

        var formattedValue = moment(rawValue, bq.config.dateFormat, true);

        return formattedValue.isValid()
            ? formattedValue.format('YYYY-MM-DD')
            : rawValue;
    },

    // ─── Schedules ────────────────────────────────────────────────────────────

    _initSchedules: function() {
        var self = this;

        $('#sched-prev-year').on('click.forecastsManager', function() {
            if (self._schedState.currentYear > self._minYear) {
                self._schedState.currentYear--;
                $('#sched-current-year').text(self._schedState.currentYear);
                self._renderCalendar();
            }
        });

        $('#sched-next-year').on('click.forecastsManager', function() {
            if (self._schedState.currentYear < self._maxYear) {
                self._schedState.currentYear++;
                $('#sched-current-year').text(self._schedState.currentYear);
                self._renderCalendar();
            }
        });

        $('#sched-create-new').on('click.forecastsManager', function() { self._openScheduleCreator(null); });

        $('#sched-group-upload-btn').on('click.forecastsManager', function() { self._openGroupUploadsModal(); });

        $('#sched-group-download-associations-btn').attr('href', this.options.downloadScheduleGroupAssociationsUrl);

        $(document)
            .off('click.forecastsManagerClose', '#group-uploads-modal-close, #group-uploads-modal-close *')
            .on('click.forecastsManagerClose', '#group-uploads-modal-close, #group-uploads-modal-close *', function(e) {
                e.preventDefault();
                $('#sched-group-uploads-modal').hide();
            });

        $('#sched-group-uploads-modal').on('click.forecastsManager', function(e) {
            if ($(e.target).is('#sched-group-uploads-modal')) $(this).hide();
        });

        $('#group-uploads-refresh').on('click.forecastsManager', function() { self._loadGroupUploadsRecentUploads(); });

        $(document).on('click.forecastsManager', '.rec-upload-error-link', function(e) {
            e.preventDefault();
            var raw = $(this).attr('data-error');
            var det;
            try { det = JSON.parse(raw); } catch(ex) { det = { raw: raw }; }
            var display = (det && det.type === 'system_error')
                ? { message: 'System error while processing, please try again' }
                : det;
            var pretty = JSON.stringify(display, null, 2)
                .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            var w = window.open('', '_blank');
            w.document.write('<pre style="font-family:monospace;font-size:14px;padding:24px;line-height:1.5">' + pretty + '</pre>');
            w.document.close();
        });

        $('#group-uploads-upload-btn').on('click.forecastsManager', function() { self._uploadGroupsFile(); });

        $('#sched-cancel').on('click.forecastsManager', function() {
            $('#sched-creator').hide();
            self._schedState.savedSelections = [];
            self._schedState.startDate = null;
            self._schedState.endDate   = null;
        });

        $('#sched-save').on('click.forecastsManager', function() { self._saveSchedule(); });

        this._loadSchedules();
    },

    _dateToString: function(date) {
        return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    },

    _stringToDate: function(dateStr) {
        var parts = dateStr.split('-').map(Number);
        return new Date(parts[0], parts[1] - 1, parts[2]);
    },

    _formatDateDisplay: function(date) {
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    },

    _isSameDay: function(d1, d2) {
        return this._dateToString(d1) === this._dateToString(d2);
    },

    _getDaysInMonth: function(year, month) {
        return new Date(year, month + 1, 0).getDate();
    },

    _getFirstDayOfMonth: function(year, month) {
        return new Date(year, month, 1).getDay();
    },

    _rangesOverlap: function(r1, r2) {
        return r1.start <= r2.end && r2.start <= r1.end;
    },

    _checkForOverlap: function(newStart, newEnd) {
        var newRange = { start: newStart, end: newEnd };
        for (var i = 0; i < this._schedState.savedSelections.length; i++) {
            if (this._rangesOverlap(newRange, this._schedState.savedSelections[i])) {
                return { overlaps: true, index: i, existingRange: this._schedState.savedSelections[i] };
            }
        }
        return { overlaps: false };
    },

    _handleDayClick: function(clickedDate) {
        var state  = this._schedState;
        var labels = bq.messages.recommendations;

        if (!state.startDate) {
            state.startDate = clickedDate;
            state.endDate   = null;
        } else if (state.startDate && !state.endDate) {
            var proposedStart, proposedEnd;
            if (this._isSameDay(clickedDate, state.startDate)) {
                proposedStart = new Date(state.startDate);
                proposedEnd   = new Date(state.startDate);
            } else if (clickedDate > state.startDate) {
                proposedStart = new Date(state.startDate);
                proposedEnd   = new Date(clickedDate);
            } else {
                proposedStart = new Date(clickedDate);
                proposedEnd   = new Date(state.startDate);
            }
            var overlapCheck = this._checkForOverlap(proposedStart, proposedEnd);
            if (overlapCheck.overlaps) {
                alert(labels.overlapWarning +
                    this._formatDateDisplay(overlapCheck.existingRange.start) + ' → ' +
                    this._formatDateDisplay(overlapCheck.existingRange.end) + '\n\n' +
                    labels.selectNonOverlapping);
                state.startDate = null;
                state.endDate   = null;
                this._updateCalendarDisplay();
                return;
            }
            state.savedSelections.push({ start: proposedStart, end: proposedEnd });
            state.startDate = null;
            state.endDate   = null;
        }
        this._updateCalendarDisplay();
    },

    _handleDayHover: function(date) {
        var state = this._schedState;
        if (state.startDate && !state.endDate) {
            state.hoverDate = date;
            this._updateCalendarDisplay();
        }
    },

    _handleDayLeave: function() {
        var state = this._schedState;
        if (state.startDate && !state.endDate) {
            state.hoverDate = null;
            this._updateCalendarDisplay();
        }
    },

    _removeSelection: function(index) {
        this._schedState.savedSelections.splice(index, 1);
        this._updateCalendarDisplay();
    },

    _updateCalendarDisplay: function() {
        var self   = this;
        var state  = this._schedState;
        var labels = bq.messages.recommendations;

        $('#sched-calendar-grid .day:not(.empty)').each(function() {
            var $dayDiv = $(this);
            var date    = self._stringToDate($dayDiv.attr('data-date'));
            $dayDiv.removeClass('start-date end-date in-range hover-preview hover-end');
            $dayDiv.css({ background: '', color: '', fontWeight: '', transform: '', zIndex: '', boxShadow: '' });

            for (var i = 0; i < state.savedSelections.length; i++) {
                var sel      = state.savedSelections[i];
                var dateStr  = self._dateToString(date);
                var startStr = self._dateToString(sel.start);
                var endStr   = self._dateToString(sel.end);
                if (dateStr === startStr && dateStr === endStr) {
                    $dayDiv.addClass('start-date end-date').css({ background: 'linear-gradient(135deg,#48bb78 0%,#48bb78 50%,#4299e1 50%,#4299e1 100%)', color: 'white', fontWeight: '600' });
                } else if (dateStr === startStr) {
                    $dayDiv.addClass('start-date').css({ background: '#48bb78', color: 'white', fontWeight: '600' });
                } else if (dateStr === endStr) {
                    $dayDiv.addClass('end-date').css({ background: '#4299e1', color: 'white', fontWeight: '600' });
                } else if (date > sel.start && date < sel.end) {
                    $dayDiv.addClass('in-range').css({ background: '#48bb78', color: 'white' });
                }
            }

            if (state.startDate && self._dateToString(date) === self._dateToString(state.startDate)) {
                $dayDiv.addClass('start-date').css({ background: '#48bb78', color: 'white', fontWeight: '600' });
            } else if (state.startDate && !state.endDate && state.hoverDate) {
                var start = state.startDate;
                var hover = state.hoverDate;
                if (hover > start) {
                    if (self._dateToString(date) === self._dateToString(hover)) {
                        $dayDiv.addClass('hover-end').css({ background: '#90cdf4', color: '#1a365d', transform: 'scale(1.2)', zIndex: '20', boxShadow: '0 4px 12px rgba(66,153,225,0.4)' });
                    } else if (date > start && date < hover) {
                        $dayDiv.addClass('hover-preview').css({ background: '#bee3f8', color: '#2c5282' });
                    }
                } else if (hover < start) {
                    if (self._dateToString(date) === self._dateToString(hover)) {
                        $dayDiv.addClass('hover-end').css({ background: '#90cdf4', color: '#1a365d', transform: 'scale(1.2)', zIndex: '20', boxShadow: '0 4px 12px rgba(66,153,225,0.4)' });
                    } else if (date > hover && date < start) {
                        $dayDiv.addClass('hover-preview').css({ background: '#bee3f8', color: '#2c5282' });
                    }
                }
            }
        });

        var $selList = $('#sched-selections-list');
        var isNewDesign = this._isNewDesign();
        if (state.savedSelections.length === 0) {
            $selList.html('<div class="rec-no-periods">' + labels.noPeriodsSelected + '</div>');
        } else {
            var html = '';
            state.savedSelections.forEach(function(sel, index) {
                html += '<div class="rec-selection-item">' +
                    '<div class="rec-selection-item__dates">' + self._formatDateDisplay(sel.start) + ' → ' + self._formatDateDisplay(sel.end) + '</div>' +
                    (isNewDesign
                        ? '<button type="button" class="action-icon-circle delete" onclick="schedRemoveSelection(' + index + ')" aria-label="' + self._escHTMLAttr(labels.remove) + '" title="' + self._escHTMLAttr(labels.remove) + '"><span class="fa fa-trash-o" aria-hidden="true"></span></button>'
                        : '<button type="button" class="btn btn-xs btn-danger" onclick="schedRemoveSelection(' + index + ')">' + labels.remove + '</button>') +
                    '</div>';
            });
            $selList.html(html);
        }
    },

    _createMonth: function(year, monthIndex) {
        var self       = this;
        var labels     = bq.messages.recommendations;
        var $month     = $('<div>').css({ background: '#f7fafc', borderRadius: '8px', padding: '12px' });
        var $monthName = $('<div>').css({ fontSize: '13px', fontWeight: '600', color: '#2d3748', marginBottom: '8px', textAlign: 'center' }).text(this.options.labels.monthNames[monthIndex]);
        var $daysGrid  = $('<div>').css({ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px' });

        this.options.labels.dayHeaders.forEach(function(day) {
            $('<div>').css({ fontSize: '9px', fontWeight: '600', color: '#718096', textAlign: 'center', padding: '4px 0' }).text(day).appendTo($daysGrid);
        });

        var daysInMonth = this._getDaysInMonth(year, monthIndex);
        var firstDay    = this._getFirstDayOfMonth(year, monthIndex);

        for (var i = 0; i < firstDay; i++) {
            $('<div>').addClass('day empty').appendTo($daysGrid);
        }
        for (var day = 1; day <= daysInMonth; day++) {
            var date    = new Date(year, monthIndex, day);
            var dateStr = this._dateToString(date);
            var $day    = $('<div>').addClass('day').text(day).attr('data-date', dateStr).css({
                aspectRatio: '1', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '11px', borderRadius: '4px', cursor: 'pointer', color: '#2d3748', position: 'relative'
            });
            (function(d) {
                $day.on('click',      function() { self._handleDayClick(d); });
                $day.on('mouseenter', function() { self._handleDayHover(d); });
                $day.on('mouseleave', function() { self._handleDayLeave(); });
            })(date);
            $daysGrid.append($day);
        }

        $month.append($monthName).append($daysGrid);
        return $month;
    },

    _updateYearButtons: function() {
        var state = this._schedState;
        $('#sched-prev-year').prop('disabled', state.currentYear <= this._minYear);
        $('#sched-next-year').prop('disabled', state.currentYear >= this._maxYear);
    },

    _renderCalendar: function() {
        var $grid = $('#sched-calendar-grid');
        $grid.empty();
        for (var month = 0; month < 12; month++) {
            $grid.append(this._createMonth(this._schedState.currentYear, month));
        }
        this._updateCalendarDisplay();
        this._updateYearButtons();
    },

    _openScheduleCreator: function(schedule) {
        var self   = this;
        var labels = bq.messages.recommendations;
        var state  = this._schedState;

        if (schedule) {
            $('#sched-creator-title').text(labels.editSchedule);
            $('#sched-edit-id').val(schedule.external_id);
            $('#sched-name').val(schedule.schedule_name);
            state.savedSelections = schedule.date_ranges.map(function(dr) {
                return {
                    start: self._stringToDate(dr.start_date.substring(0, 10)),
                    end:   self._stringToDate(dr.end_date.substring(0, 10))
                };
            });
        } else {
            $('#sched-creator-title').text(labels.createSchedule);
            $('#sched-edit-id').val('');
            $('#sched-name').val('');
            state.savedSelections = [];
        }

        state.startDate   = null;
        state.endDate     = null;
        state.hoverDate   = null;
        state.currentYear = this._currentYearBase;
        $('#sched-current-year').text(state.currentYear);
        $('#sched-creator').show();
        this._renderCalendar();
    },

    _editSchedule: function(schedule) {
        this._openScheduleCreator(schedule);
        $('html, body').animate({ scrollTop: $('#sched-creator').offset().top - 20 }, 300);
    },

    _saveSchedule: function() {
        var self   = this;
        var o      = this.options;
        var labels = o.labels;
        var state  = this._schedState;

        var scheduleName = $('#sched-name').val().trim();
        var editId       = $('#sched-edit-id').val();

        if (!scheduleName) { alert(labels.pleaseEnterScheduleName); return; }
        if (state.savedSelections.length === 0) { alert(labels.pleaseSelectDateRange); return; }

        var dateRanges = state.savedSelections.map(function(sel) {
            return { start_date: self._dateToString(sel.start), end_date: self._dateToString(sel.end) };
        });

        var url     = editId ? o.updateScheduleUrl : o.writeScheduleUrl;
        var payload = editId
            ? { external_id: editId, schedule_name: scheduleName, date_ranges: dateRanges }
            : { schedule_name: scheduleName, status: 'ACTIVE', date_ranges: dateRanges };
        var failMsg = editId ? labels.failedToUpdateSchedule : labels.failedToSaveSchedule;

        $.ajax({ url: url, type: 'POST', dataType: 'json', contentType: 'application/json', data: JSON.stringify(payload) })
            .done(function(resp) {
                if (resp && resp.success) { $('#sched-creator').hide(); self._loadSchedules(); }
                else alert((resp && resp.error) || failMsg);
            })
            .fail(function(xhr) { alert((xhr.responseJSON && xhr.responseJSON.error) || failMsg); });
    },

    _loadSchedules: function() {
        var self   = this;
        var labels = bq.messages.recommendations;
        $.ajax({ url: this.options.readSchedulesUrl, type: 'POST', dataType: 'json', contentType: 'application/json', data: JSON.stringify({}) })
            .done(function(schedules) { self._renderSchedules(Array.isArray(schedules) ? schedules : []); })
            .fail(function() { $('#sched-list').html('<p class="text-danger">' + labels.failedToLoadSchedules + '</p>'); });
    },

    _renderSchedules: function(schedules) {
        var self   = this;
        var labels = bq.messages.recommendations;
        var $list  = $('#sched-list');
        $list.empty();
        if (schedules.length === 0) {
            $list.html('<p class="text-muted">' + labels.noSchedulesSaved + '</p>');
            return;
        }
        schedules.forEach(function(sched) {
            var $item = $('<div>').css({
                padding: '20px', marginBottom: '16px', background: '#ffffff',
                border: '1px solid #e2e8f0', borderRadius: '8px',
                boxShadow: '0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06)',
                transition: 'box-shadow 0.2s'
            }).hover(
                function() { $(this).css('boxShadow', '0 4px 6px -1px rgba(0,0,0,0.1),0 2px 4px -1px rgba(0,0,0,0.06)'); },
                function() { $(this).css('boxShadow', '0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06)'); }
            );
            var $header = $('<div>').css({ marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e2e8f0' });
            $('<h4>').css({ margin: 0, fontSize: '18px', fontWeight: '600', color: '#1a202c' }).text(sched.schedule_name).appendTo($header);
            $item.append($header);
            if (sched.date_ranges && sched.date_ranges.length > 0) {
                $item.append(self._createScheduleCalendarViewWithButtons(sched));
            }
            $list.append($item);
        });
    },

    _createScheduleCalendarViewWithButtons: function(sched) {
        var self    = this;
        var labels  = bq.messages.recommendations;
        var isNewDesign = this._isNewDesign();
        var $wrapper = $('<div>').addClass('rec-sched-panel');
        var $btnGroup = $('<div>').addClass('rec-sched-btn-group');

        $('<button>').attr('type', 'button').addClass('btn btn-primary rec-sched-btn')
            .html('<i class="fa fa-calendar rec-icon--fixed"></i> <span>' + labels.scheduleForecastingPeriods + '</span>')
            .on('click', function() { self._editSchedule(sched); }).appendTo($btnGroup);

        $('<button>').attr('type', 'button').addClass('btn btn-primary rec-sched-btn')
            .html('<i class="fa fa-users rec-icon--fixed"></i> <span>' + labels.manageScheduleGroups + '</span>')
            .on('click', function() { self._openGroupSelectionModal(sched); }).appendTo($btnGroup);

        $('<button>').attr('type', 'button').addClass(isNewDesign ? 'action-icon-circle delete rec-sched-btn rec-sched-btn--delete' : 'btn btn-danger rec-sched-btn')
            .html(isNewDesign
                ? '<span class="fa fa-trash-o" aria-hidden="true"></span>'
                : '<i class="fa fa-trash-o rec-icon--fixed"></i> <span>' + labels.deleteScheduleLabel + '</span>')
            .attr(isNewDesign ? {
                'aria-label': labels.deleteScheduleLabel,
                'title': labels.deleteScheduleLabel
            } : {})
            .on('click', function() { self._deleteSchedule(sched.external_id); }).appendTo($btnGroup);

        $wrapper.append(this._createScheduleCalendarView(sched)).append($btnGroup);
        return $wrapper;
    },

    _createScheduleCalendarView: function(sched) {
        var self    = this;
        var labels  = bq.messages.recommendations;
        var ranges  = sched.date_ranges.map(function(dr) {
            return { start: self._stringToDate(dr.start_date.substring(0, 10)), end: self._stringToDate(dr.end_date.substring(0, 10)) };
        });
        var today       = new Date();
        var latestDate  = new Date(Math.max.apply(null, ranges.map(function(r) { return r.end; })));
        var viewState   = { currentMonth: today.getMonth(), currentYear: today.getFullYear(), minYear: today.getFullYear(), minMonth: today.getMonth(), maxYear: latestDate.getFullYear(), maxMonth: latestDate.getMonth() };
        var $container  = $('<div>').css({ background: '#f8fafc', borderRadius: '6px', padding: '12px', width: '420px', flex: '0 0 420px', border: '1px solid #e2e8f0' });
        var $nav        = $('<div>').css({ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', padding: '4px 0' });
        var navBtnCss   = { background: '#ffffff', border: '1px solid #cbd5e0', borderRadius: '4px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '14px', color: '#4a5568', transition: 'all 0.2s' };

        var $prevBtn    = $('<button>').attr('type','button').css(navBtnCss).html('&larr;').hover(
            function() { if (!$(this).prop('disabled')) $(this).css({ background: '#edf2f7', borderColor: '#a0aec0' }); },
            function() { if (!$(this).prop('disabled')) $(this).css({ background: '#ffffff', borderColor: '#cbd5e0' }); }
        );
        var $monthLabel = $('<span>').css({ fontSize: '15px', fontWeight: '600', color: '#2d3748', letterSpacing: '0.3px' }).text(this.options.labels.monthNames[today.getMonth()] + ' ' + today.getFullYear());
        var $nextBtn    = $('<button>').attr('type','button').css(navBtnCss).html('&rarr;').hover(
            function() { if (!$(this).prop('disabled')) $(this).css({ background: '#edf2f7', borderColor: '#a0aec0' }); },
            function() { if (!$(this).prop('disabled')) $(this).css({ background: '#ffffff', borderColor: '#cbd5e0' }); }
        );
        $nav.append($prevBtn).append($monthLabel).append($nextBtn);

        var $calCont = $('<div>');

        function updateCalendarView() {
            $calCont.empty();
            $monthLabel.text(self.options.labels.monthNames[viewState.currentMonth] + ' ' + viewState.currentYear);
            $calCont.append(self._createMiniCalendar(viewState.currentYear, viewState.currentMonth, ranges));
            var atStart = (viewState.currentYear === viewState.minYear && viewState.currentMonth === viewState.minMonth);
            var atEnd   = (viewState.currentYear === viewState.maxYear && viewState.currentMonth === viewState.maxMonth);
            $prevBtn.prop('disabled', atStart).css({ opacity: atStart ? '0.4' : '1', cursor: atStart ? 'not-allowed' : 'pointer' });
            $nextBtn.prop('disabled', atEnd).css({ opacity: atEnd ? '0.4' : '1', cursor: atEnd ? 'not-allowed' : 'pointer' });
        }

        $prevBtn.on('click', function() {
            if (viewState.currentMonth === 0) { viewState.currentMonth = 11; viewState.currentYear--; }
            else { viewState.currentMonth--; }
            updateCalendarView();
        });
        $nextBtn.on('click', function() {
            if (viewState.currentMonth === 11) { viewState.currentMonth = 0; viewState.currentYear++; }
            else { viewState.currentMonth++; }
            updateCalendarView();
        });

        updateCalendarView();
        $container.append($nav).append($calCont);
        return $container;
    },

    _createMiniCalendar: function(year, month, ranges) {
        var self        = this;
        var daysInMonth = this._getDaysInMonth(year, month);
        var firstDay    = this._getFirstDayOfMonth(year, month);
        var weeksNeeded = Math.ceil((firstDay + daysInMonth) / 7);
        var maxWeeks    = 6;
        var weekHeight  = 36;
        var vPad        = weeksNeeded < maxWeeks ? ((maxWeeks - weeksNeeded) * weekHeight) / 2 : 0;

        var $cal = $('<div>').css({
            display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px',
            background: '#ffffff', padding: '8px',
            paddingTop: (8 + vPad) + 'px', paddingBottom: (8 + vPad) + 'px',
            borderRadius: '4px', minHeight: (maxWeeks * weekHeight + 16 + 28) + 'px'
        });

        this.options.labels.dayHeaders.forEach(function(day) {
            $('<div>').css({ fontSize: '10px', fontWeight: '600', color: '#718096', textAlign: 'center', padding: '4px 0', textTransform: 'uppercase', letterSpacing: '0.5px', height: '28px' }).text(day).appendTo($cal);
        });

        for (var i = 0; i < firstDay; i++) {
            $('<div>').css({ minHeight: '32px', height: '32px' }).appendTo($cal);
        }

        for (var day = 1; day <= daysInMonth; day++) {
            var date    = new Date(year, month, day);
            var dateStr = self._dateToString(date);
            var isStart = false, isEnd = false, isInRange = false;

            for (var j = 0; j < ranges.length; j++) {
                var range    = ranges[j];
                var startStr = self._dateToString(range.start);
                var endStr   = self._dateToString(range.end);
                if (dateStr === startStr && dateStr === endStr) { isStart = isEnd = isInRange = true; break; }
                else if (dateStr === startStr) { isStart = isInRange = true; break; }
                else if (dateStr === endStr)   { isEnd   = isInRange = true; break; }
                else if (date >= range.start && date <= range.end) { isInRange = true; break; }
            }

            var bgColor = 'transparent', color = '#2d3748', fontWeight = 'normal', boxShadow = 'none';
            if (isStart && isEnd) {
                bgColor = 'linear-gradient(135deg,#48bb78 0%,#48bb78 50%,#4299e1 50%,#4299e1 100%)';
                color = 'white'; fontWeight = '600'; boxShadow = '0 1px 3px rgba(0,0,0,0.12)';
            } else if (isStart) {
                bgColor = '#48bb78'; color = 'white'; fontWeight = '600'; boxShadow = '0 1px 3px rgba(72,187,120,0.3)';
            } else if (isEnd) {
                bgColor = '#4299e1'; color = 'white'; fontWeight = '600'; boxShadow = '0 1px 3px rgba(66,153,225,0.3)';
            } else if (isInRange) {
                bgColor = '#48bb78'; color = 'white';
            }

            $('<div>').css({
                minHeight: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '11px', borderRadius: '4px', background: bgColor, color: color,
                fontWeight: fontWeight, boxShadow: boxShadow, transition: 'transform 0.1s'
            }).text(day).appendTo($cal);
        }
        return $cal;
    },

    _deleteSchedule: function(externalId) {
        var self   = this;
        var labels = bq.messages.recommendations;
        if (!confirm(labels.areYouSureDelete)) return;
        $.ajax({ url: this.options.deleteScheduleUrl, type: 'POST', dataType: 'json', contentType: 'application/json', data: JSON.stringify({ external_id: externalId }) })
            .done(function(resp) {
                if (resp && resp.success) self._loadSchedules();
                else alert(labels.failedToDeleteSchedule);
            })
            .fail(function() { alert(labels.failedToDeleteSchedule); });
    },

    _openGroupUploadsModal: function() {
        $('#group-uploads-result').hide();
        $('#group-uploads-file').val('');
        $('#sched-group-uploads-modal').show();
        this._loadGroupUploadsRecentUploads();
    },

    _loadGroupUploadsRecentUploads: function() {
        var self    = this;
        var o       = this.options;
        var labels  = o.labels;
        var $cont   = $('#group-uploads-list');
        $cont.html('<span class="rec-text-loading">' + labels.loading + '</span>');
        $.ajax({
            url: o.readScheduleGroupUploadsUrl, type: 'POST',
            contentType: 'application/json', data: JSON.stringify({}), dataType: 'json',
            success: function(data) {
                if (!Array.isArray(data) || data.length === 0) {
                    $cont.html('<span class="rec-text-loading">' + labels.noRecentUploads + '</span>');
                    return;
                }
                var statusColors = { PENDING: '#718096', STREAMING: '#3182ce', PROCESSING: '#d69e2e', COMPLETED: '#38a169', FAILED: '#e53e3e' };
                var statusIcons  = { PENDING: 'fa-clock-o', STREAMING: 'fa-cloud-upload', PROCESSING: 'fa-spinner fa-spin', COMPLETED: 'fa-check-circle', FAILED: 'fa-times-circle' };
                var html = '<table class="rec-upload-table"><thead><tr>' +
                    '<th class="rec-upload-table__col-file">' + labels.fileName + '</th>' +
                    '<th>' + labels.status + '</th>' +
                    '<th class="rec-upload-table__col-rows">' + labels.rows + '</th>' +
                    '<th></th>' +
                    '</tr></thead><tbody>';
                data.forEach(function(u) {
                    var color   = statusColors[u.status] || '#718096';
                    var icon    = statusIcons[u.status]  || 'fa-question-circle';
                    var d       = new Date(u.created_at);
                    var dateStr = d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
                    var statusLabel;
                    if (u.status === 'FAILED' && u.error_details) {
                        var errJson = JSON.stringify(u.error_details, null, 2);
                        statusLabel = '<a href="#" class="rec-upload-error-link" data-error="' + errJson.replace(/&/g,'&amp;').replace(/"/g,'&quot;') + '">' + u.status + '</a>';
                    } else {
                        statusLabel = u.status;
                    }
                    var dlBtn = u.row_count > 0
                        ? '<a href="' + o.downloadScheduleGroupUploadUrl + '?external_id=' + encodeURIComponent(u.external_id) + '" class="btn btn-xs btn-default"><i class="fa fa-download"></i> ' + labels.download + '</a>'
                        : '';
                    html += '<tr>' +
                        '<td class="rec-upload-table__filename">' + (u.file_name || u.external_id) + '<br><span class="rec-upload-table__date">' + dateStr + '</span></td>' +
                        '<td class="rec-upload-table__status" style="color:' + color + '"><i class="fa ' + icon + '"></i> ' + statusLabel + '</td>' +
                        '<td>' + u.row_count + '</td>' +
                        '<td>' + dlBtn + '</td></tr>';
                });
                $cont.html(html + '</tbody></table>');
            },
            error: function() { $cont.html('<span class="rec-text-error">' + labels.failedToLoadUploads + '</span>'); }
        });
    },

    _uploadGroupsFile: function() {
        var self      = this;
        var o         = this.options;
        var labels    = o.labels;
        var fileInput = $('#group-uploads-file')[0];
        if (!fileInput.files || !fileInput.files[0]) { alert(labels.pleaseSelectCsvFile); return; }
        var formData   = new FormData();
        formData.append('file', fileInput.files[0]);
        var $uploadBtn = $('#group-uploads-upload-btn');
        var $resultDiv = $('#group-uploads-result');
        $uploadBtn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> ' + labels.uploading);
        $resultDiv.hide();
        $.ajax({ url: o.uploadScheduleGroupsUrl, type: 'POST', data: formData, processData: false, contentType: false, dataType: 'json',
            success: function(resp) {
                if (resp.success) {
                    $resultDiv.show().removeClass('rec-result-error').addClass('rec-result-success').html(
                        '<i class="fa fa-check-circle rec-icon--success"></i> ' +
                        labels.uploadAccepted + ' ' + resp.row_count + ' ' + labels.rowsSubmitted +
                        '<br><span class="rec-result-id">' + labels.uploadId + ' ' + (resp.file_name || resp.external_id) + '</span>'
                    );
                } else {
                    var errHtml = '<i class="fa fa-exclamation-circle rec-icon--error"></i> ' + (resp.error || labels.uploadFailed);
                    if (resp.validation_errors && resp.validation_errors.length > 0) {
                        errHtml += '<div class="rec-validation-errors"><ul>';
                        resp.validation_errors.forEach(function(err) { errHtml += '<li>' + $('<span>').text(err).html() + '</li>'; });
                        errHtml += '</ul></div>';
                    }
                    $resultDiv.show().removeClass('rec-result-success').addClass('rec-result-error').html(errHtml);
                }
                fileInput.value = '';
                self._loadGroupUploadsRecentUploads();
            },
            error: function(xhr) {
                var msg = labels.uploadFailed, extraHtml = '';
                try {
                    var r = JSON.parse(xhr.responseText);
                    if (r.error) msg = r.error;
                    if (r.validation_errors && r.validation_errors.length > 0) {
                        extraHtml = '<div class="rec-validation-errors"><ul>';
                        r.validation_errors.forEach(function(err) { extraHtml += '<li>' + $('<span>').text(err).html() + '</li>'; });
                        extraHtml += '</ul></div>';
                    }
                } catch(e) {}
                $resultDiv.show().removeClass('rec-result-success').addClass('rec-result-error').html('<i class="fa fa-exclamation-circle rec-icon--error"></i> ' + msg + extraHtml);
            },
            complete: function() { $uploadBtn.prop('disabled', false).html('<i class="fa fa-upload"></i> ' + labels.upload); }
        });
    },

    _openGroupSelectionModal: function(schedule) {
        var self    = this;
        var o       = this.options;
        var labels  = o.labels;
        var modalId = 'sched-group-modal';
        var isNewDesign = this._isNewDesign();
        var $existing = $('#' + modalId);
        if ($existing.length > 0) $existing.remove();

        var modalHtml = '<div class="modal fade" id="' + modalId + '" tabindex="-1" role="dialog">' +
            '<div class="modal-dialog" role="document"><div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
            '<h4 class="modal-title">' + labels.manageContentGroups + ' - ' + this._escHTML(schedule.schedule_name) + '</h4>' +
            '</div><div class="modal-body">' +
            '<p class="text-muted">' + labels.selectContentGroupsFor + '</p>' +
            '<div class="form-group"><div id="' + modalId + '-groups-container" class="rec-groups-container">';

        if (this._contentGroups.length > 0) {
            this._contentGroups.forEach(function(group) {
                modalHtml += '<div class="checkbox"><label' + (isNewDesign ? ' class="checkbox-wrapper"' : '') + '>' +
                    '<input type="checkbox" class="sched-group-checkbox" value="' + self._escHTMLAttr(String(group.id)) + '">' +
                    (isNewDesign ? '<span></span>' : self._escHTML(group.name)) +
                    '</label>' +
                    (isNewDesign ? self._escHTML(group.name) : '') +
                    '</div>';
            });
        } else {
            modalHtml += '<p class="text-muted">' + labels.noContentGroups + '</p>';
        }

        modalHtml += '</div></div>' +
            '<div id="' + modalId + '-status" class="alert rec-modal-status" style="display:none;"></div>' +
            '</div><div class="modal-footer">' +
            '<button type="button" class="btn btn-default" data-dismiss="modal">' + labels.cancel + '</button>' +
            '<button type="button" class="btn btn-primary" id="' + modalId + '-save">' + labels.save + '</button>' +
            '</div></div></div></div>';

        $('body').append(modalHtml);

        var $modal        = $('#' + modalId);
        var $saveBtn      = $('#' + modalId + '-save');
        var $status       = $('#' + modalId + '-status');
        var initialActive = {};
        var initialLoaded = false;
        var groupNameById = {};

        function applyScheduleGroups(groups) {
            initialActive = {};
            if (Array.isArray(groups)) {
                groups.forEach(function(g) {
                    if (g && g.group_id && g.status === 'ACTIVE') initialActive[String(g.group_id)] = true;
                });
            }
            $('.sched-group-checkbox').each(function() {
                var gId  = String($(this).val());
                var name = $(this).closest('label').text().trim();
                if (name) groupNameById[gId] = name;
                $(this).prop('checked', !!initialActive[gId]);
            });
        }

        function loadScheduleGroups() {
            $status.removeClass('alert-success alert-danger').addClass('alert-info').text(labels.loadingScheduleGroups).show();
            return $.ajax({ url: o.readScheduleGroupsUrl, type: 'POST', dataType: 'json', contentType: 'application/json', data: JSON.stringify({ external_id: schedule.external_id }) })
                .done(function(resp) {
                    var groups = (resp && resp.data && Array.isArray(resp.data)) ? resp.data : resp;
                    applyScheduleGroups(groups);
                    initialLoaded = true;
                    $status.hide();
                })
                .fail(function() {
                    initialLoaded = false;
                    $status.removeClass('alert-info').addClass('alert-danger').text(labels.failedToLoadScheduleGroups);
                });
        }

        $saveBtn.on('click', function() {
            if (!initialLoaded) {
                $status.removeClass('alert-success alert-danger').addClass('alert-danger').text(labels.scheduleGroupsNotLoaded).show();
                return;
            }
            var selectedGroups = [];
            $('.sched-group-checkbox:checked').each(function() { selectedGroups.push($(this).val()); });
            var selectedSet  = {};
            selectedGroups.forEach(function(gId) { selectedSet[String(gId)] = true; });
            var toActivate   = Object.keys(selectedSet).filter(function(gId) { return !initialActive[gId]; });
            var toDeactivate = Object.keys(initialActive).filter(function(gId) { return !selectedSet[gId]; });

            if (toActivate.length === 0 && toDeactivate.length === 0) {
                $status.removeClass('alert-success alert-danger').addClass('alert-info').text(labels.noChangesToSave).show();
                return;
            }

            $saveBtn.prop('disabled', true).text(labels.saving);
            $status.removeClass('alert-success alert-danger').addClass('alert-info').text(labels.preparingBatches).show();

            var batchSize       = 100;
            var activateBatches = [], deactivateBatches = [];
            for (var i = 0; i < toActivate.length;   i += batchSize) activateBatches.push(toActivate.slice(i, i + batchSize));
            for (var j = 0; j < toDeactivate.length; j += batchSize) deactivateBatches.push(toDeactivate.slice(j, j + batchSize));
            var totalBatches = Math.max(activateBatches.length, deactivateBatches.length);
            var results      = { processed: 0, conflicts: 0, failed: 0, failedGroups: [], conflictDetails: [] };

            function addConflicts(conflicts) {
                if (!Array.isArray(conflicts)) return;
                conflicts.forEach(function(conflict) {
                    var rawGId   = String(conflict.group_id || conflict.group_fk || '');
                    var gLabel   = groupNameById[rawGId] || rawGId;
                    var sName    = self._escHTML(conflict.conflict_schedule_name || '');
                    var sLabel   = sName || self._escHTML(conflict.conflict_schedule_fk || '');
                    if (sLabel) results.conflictDetails.push(labels.group + ' ' + self._escHTML(gLabel) + ' ' + labels.isCurrentlyAssociatedWith + ' ' + sLabel);
                });
            }

            function normalizeResp(resp) { return (resp && resp.data) ? resp.data : resp; }

            function updateStatus(batchIndex) {
                $status.text(labels.savingBatch + ' ' + (batchIndex + 1) + ' ' + labels.of + ' ' + totalBatches +
                    ' (' + results.processed + ' ' + labels.processed + ', ' + results.conflicts + ' ' + labels.conflicts + ', ' + results.failed + ' ' + labels.failedLower + ')');
            }

            function summarizeResults() {
                var s = labels.done + ' ' + results.processed + ' ' + labels.processed + ', ' + results.conflicts + ' ' + labels.conflicts + ', ' + results.failed + ' ' + labels.failedLower + '.';
                if (results.failedGroups.length > 0)    s += '<br>' + labels.failedGroupIds + ' ' + self._escHTML(results.failedGroups.join(', '));
                if (results.conflictDetails.length > 0) s += '<br>' + labels.conflictsLabel + '<br>' + results.conflictDetails.join('<br>');
                return s;
            }

            function sendBatch(batchIndex) {
                if (batchIndex >= totalBatches) {
                    $saveBtn.prop('disabled', false).text(labels.save);
                    var cls = (results.failed > 0 || results.conflicts > 0) ? 'alert-danger' : 'alert-success';
                    $status.removeClass('alert-info').addClass(cls).html(summarizeResults());
                    if (results.failed === 0 && results.conflicts === 0) setTimeout(function() { $modal.modal('hide'); }, 1500);
                    return;
                }
                updateStatus(batchIndex);
                var aBatch = activateBatches[batchIndex]   || [];
                var dBatch = deactivateBatches[batchIndex] || [];
                $.ajax({ url: o.writeScheduleGroupsUrl, type: 'POST', dataType: 'json', contentType: 'application/json',
                    data: JSON.stringify({ external_id: schedule.external_id, activate_group_ids: aBatch, deactivate_group_ids: dBatch })
                }).done(function(resp) {
                    var data = normalizeResp(resp);
                    if (data && data.schedule_groups && Array.isArray(data.schedule_groups)) results.processed += data.schedule_groups.length;
                    if (data && data.conflicts && Array.isArray(data.conflicts)) {
                        results.conflicts += data.conflicts.length;
                        results.processed += data.conflicts.length;
                        addConflicts(data.conflicts);
                    }
                }).fail(function(xhr) {
                    if (xhr && xhr.status === 409 && xhr.responseJSON) {
                        var cr = normalizeResp(xhr.responseJSON);
                        if (cr && cr.schedule_groups && Array.isArray(cr.schedule_groups)) results.processed += cr.schedule_groups.length;
                        if (cr && cr.conflicts && Array.isArray(cr.conflicts)) {
                            results.conflicts += cr.conflicts.length;
                            results.processed += cr.conflicts.length;
                            addConflicts(cr.conflicts);
                        }
                    } else {
                        results.failed += aBatch.length + dBatch.length;
                        results.failedGroups = results.failedGroups.concat(aBatch).concat(dBatch);
                    }
                }).always(function() { sendBatch(batchIndex + 1); });
            }

            sendBatch(0);
        });

        $modal.on('hidden.bs.modal', function() { $modal.remove(); });
        $modal.modal('show');
        loadScheduleGroups();
    },

    // ─── Relation Import / Export ─────────────────────────────────────────────

    _initRelationImportExport: function() {
        var self   = this;
        var o      = this.options;
        var labels = o.labels;

        $('#rel-export-btn').attr('href', o.exportRelationsUrl);

        $('#rel-import-btn').on('click.forecastsManager', function() { self._openRelImportPanel(); });

        $('#rel-import-copy-suppliers').on('click.forecastsManager', function() {
            var names = self._relImportAllSupplierNames;
            if (names.length === 0) return;
            var text  = names.join('\n');
            var $btn  = $('#rel-import-copy-suppliers');
            var done  = function() {
                $btn.html('<i class="fa fa-check"></i> ' + labels.copied);
                setTimeout(function() { $btn.html('<i class="fa fa-clipboard"></i> ' + labels.copySuppliers); }, 2000);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(done);
            } else {
                var $ta = $('<textarea>').val(text).css({ position: 'fixed', left: '-9999px' });
                $('body').append($ta);
                $ta[0].select();
                document.execCommand('copy');
                $ta.remove();
                done();
            }
        });

        $('#rel-import-upload-btn').on('click.forecastsManager', function() { self._importRelationsCsv(); });

        $('#rel-import-cancel').on('click.forecastsManager', function() { $('#rel-import-panel').hide(); });
    },

    _openRelImportPanel: function() {
        var self   = this;
        var o      = this.options;
        var labels = o.labels;
        $('#rel-import-result').hide();
        $('#rel-import-file').val('');
        $('#rel-import-panel').show();
        var $list = $('#rel-import-suppliers-list');
        $list.html('<span class="rec-text-loading">' + labels.loadingSuppliersMsg + '</span>');
        $.ajax({ url: o.listSuppliersUrl, type: 'POST', contentType: 'application/json', data: JSON.stringify({}), dataType: 'json',
            success: function(data) {
                if (Array.isArray(data) && data.length > 0) {
                    self._relImportAllSupplierNames = data.map(function(s) { return s.supplier_name; }).sort();
                    $list.text(self._relImportAllSupplierNames.join('\n')).css('white-space', 'pre');
                } else {
                    $list.html('<span class="rec-text-loading">' + labels.noSuppliersFound + '</span>');
                }
            },
            error: function() { $list.html('<span class="rec-text-error">' + labels.failedToLoadSuppliers + '</span>'); }
        });
    },

    _importRelationsCsv: function() {
        var o         = this.options;
        var labels    = o.labels;
        var fileInput = $('#rel-import-file')[0];
        if (!fileInput.files || !fileInput.files[0]) { alert(labels.pleaseSelectCsvFile); return; }
        var formData   = new FormData();
        formData.append('file', fileInput.files[0]);
        var $uploadBtn = $('#rel-import-upload-btn');
        var $resultDiv = $('#rel-import-result');
        $uploadBtn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> ' + labels.importing);
        $resultDiv.hide();
        $.ajax({ url: o.importRelationsUrl, type: 'POST', data: formData, processData: false, contentType: false, dataType: 'json',
            success: function(resp) {
                if (resp.success) {
                    $resultDiv.show().removeClass('rec-result-error').addClass('rec-result-success').html(
                        '<i class="fa fa-check-circle rec-icon--success"></i> ' + labels.importSuccessful + ' ' + resp.row_count + ' ' + labels.relationshipsLoaded
                    );
                    fileInput.value = '';
                } else {
                    var errHtml = '<i class="fa fa-exclamation-circle rec-icon--error"></i> ' + (resp.error || labels.importFailed);
                    if (resp.validation_errors && resp.validation_errors.length > 0) {
                        errHtml += '<div class="rec-validation-errors"><ul>';
                        resp.validation_errors.forEach(function(err) { errHtml += '<li>' + $('<span>').text(err).html() + '</li>'; });
                        errHtml += '</ul></div>';
                    }
                    $resultDiv.show().removeClass('rec-result-success').addClass('rec-result-error').html(errHtml);
                }
            },
            error: function(xhr) {
                var msg = labels.importFailed, extraHtml = '';
                try {
                    var r = JSON.parse(xhr.responseText);
                    if (r.error) msg = r.error;
                    if (r.validation_errors && r.validation_errors.length > 0) {
                        extraHtml = '<div class="rec-validation-errors"><ul>';
                        r.validation_errors.forEach(function(err) { extraHtml += '<li>' + $('<span>').text(err).html() + '</li>'; });
                        extraHtml += '</ul></div>';
                    }
                } catch(e) {}
                $resultDiv.show().removeClass('rec-result-success').addClass('rec-result-error').html('<i class="fa fa-exclamation-circle rec-icon--error"></i> ' + msg + extraHtml);
            },
            complete: function() { $uploadBtn.prop('disabled', false).html(labels.import); }
        });
    }
};

var oldForecastsManager = $.fn.forecastsManager;
$.fn.forecastsManager = function(option) {
    return this.each(function() {
        var $this   = $(this);
        var data    = $this.data('bq.forecastsManager');
        var options = typeof option === 'object' && option;
        if (!data) $this.data('bq.forecastsManager', (data = new bq.forecastsManager(this, options)));
        if (typeof option === 'string') data[option]();
    });
};
$.fn.forecastsManager.Constructor = bq.forecastsManager;
$.fn.forecastsManager.noConflict  = function() { $.fn.forecastsManager = oldForecastsManager; return this; };

bq.forecastsManagerInit = function() {
    $('[data-bq="forecasts-manager"]').each(function() {
        var $el = $(this);
        if (!$el.data('bq.forecastsManager')) $el.forecastsManager();
    });
};
bq.init.push(bq.forecastsManagerInit);
bq.forecastsManagerInit();

});}( window, document, bq));
